import { ChangeDetectorRef, Component, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Misc } from '../util/misc';
import { UtilService } from 'src/app/services/util.service';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { EstimativaCronograma } from 'src/app/models/estimativa-cronograma.model';
import { EstimativaCronogramaKey } from 'src/app/models/estimativa-cronograma-key.model';
import { EstimativaCronogramaService } from 'src/app/services/estimativa-cronograma.service';
import { EstimativaCronogramaKeyService } from 'src/app/services/estimativa-cronograma-keys.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ToastrComponent } from '../util/toastr/toastr.component';
import { MatTable } from '@angular/material/table';
import { AdicionarCronogramaKeyDialogComponent } from './adicionar-cronograma-key-dialog/adicionar-cronograma-key-dialog.component';

const totalDeDiasDoMes: number = 22;
const totalDiasMaximo: number = 90;
const totalDeSemanasNoMes: number = 4;
const totalDeDiasDaSemana: number = 5;

export enum TipoCronogramaEnum {
  mensal,
  semanal
}

@Component({
  selector: 'app-cronograma-estimativa',
  templateUrl: './cronograma-estimativa.component.html',
  styleUrls: ['./cronograma-estimativa.component.scss']
})

export class CronogramaEstimativaComponent implements OnInit {
  @Input() estimativaId: number;
  @Input() somenteLeitura: boolean = false;
  @Input() hiddenResume: boolean;
  @ViewChildren(MatTable) tables: QueryList<MatTable<any>>;
  sliderMap: { [key: number]: boolean } = {};

  loading: boolean = false;

  tipoCronogramaChecked: boolean = false;
  exibirCronograma: boolean = false;
  estimativaTipo: number;
  estimativaStatus: number;
  prazoEstimativa: number;
  prazoEstimativaEmDias: number;
  prazoEstimativaSemanas: number;
  periodos: number[];

  public TipoCronogramaNome = TipoCronogramaEnum;

  tipoCronograma: TipoCronogramaEnum = TipoCronogramaEnum.mensal;

  estimativaCronograma: EstimativaCronograma;
  estimativaCronogramaKeys: EstimativaCronogramaKey[] = [];

  labels: string[] = [];

  constructor(
    private estimativaCronogramaService: EstimativaCronogramaService,
    private estimativaCronogramaKeyService: EstimativaCronogramaKeyService,
    public utilService: UtilService,
    private dialog: MatDialog,
    public misc: Misc,
    private toastr: ToastrComponent,
    private cdr: ChangeDetectorRef
  ) {
  }

  async ngOnInit() {
    this.loading = true;

    // const estimativaAlterada: boolean = await this.estimativaAlterouDados();

    // if (estimativaAlterada)
    //   this.gerarCronogramaComIA(true);
    // else
    this.carregarTela();
  }

  carregarTela() {
    this.loading = true;

    this.estimativaCronogramaService.getByEstimativaId(this.estimativaId).subscribe((resultRequest: any) => {
      if (resultRequest?.estimativaId) {
        this.prazoEstimativa = resultRequest.prazoEstimativa;
        this.prazoEstimativaEmDias = this.prazoEstimativa * totalDeDiasDoMes;
        this.prazoEstimativaSemanas = this.prazoEstimativaEmDias / totalDeDiasDaSemana;

        this.tipoCronograma = this.tipoCronogramaChecked
          ? TipoCronogramaEnum.semanal
          : TipoCronogramaEnum.mensal;

        this.periodos = this.tipoCronograma === TipoCronogramaEnum.mensal
          ? Array.from({ length: Math.ceil(this.prazoEstimativa) }, (_, i) => i + 1)
          : Array.from({ length: this.prazoEstimativaSemanas }, (_, i) => i + 1);

        this.generateLabels();

        resultRequest.keys.forEach((key: EstimativaCronogramaKey) => {
          key.inicioSlideToggle = key.diaInicio;
          key.fimSlideToggle = key.diaFim;
        });

        this.estimativaCronogramaKeys = resultRequest.keys;
        this.exibirCronograma = true;
        this.hiddenResume;
      }

      this.loading = false;
    });
  }


  generateLabels() {
    this.labels = [];
    if (this.tipoCronograma === TipoCronogramaEnum.mensal) {
      const totalMeses = Math.ceil(this.prazoEstimativaEmDias / totalDeDiasDoMes);
      this.labels = Array.from({ length: totalMeses }, (_, i) => `Mês ${i + 1}`);
    } else {
      this.labels = this.periodos.map(periodo => `Semana ${periodo}`);
    }
  }

  changeTipoCronogramaVisao(checked: boolean) {
    this.tipoCronogramaChecked = checked;
    this.tipoCronograma = checked ? TipoCronogramaEnum.semanal : TipoCronogramaEnum.mensal;

    this.periodos = this.tipoCronograma === TipoCronogramaEnum.mensal
      ? Array.from({ length: Math.ceil(this.prazoEstimativaEmDias / totalDeDiasDoMes) }, (_, i) => i + 1)
      : Array.from({ length: Math.ceil(this.prazoEstimativaEmDias / totalDeDiasDaSemana) }, (_, i) => i + 1);

    // Refazer os sliders com base na nova visão
    this.estimativaCronogramaKeys.forEach((key: EstimativaCronogramaKey) => {
      key.inicioSlideToggle = key.diaInicio ? Number(key.diaInicio) : 1;
      key.fimSlideToggle = key.diaFim ? Number(key.diaFim) : 1;
    });

    // Força a detecção de mudanças do Angular
    this.cdr.detectChanges();

    // Reinicia o layout
    setTimeout(() => {
      this.carregarTela();
    }, 0);
  }


  displaySliderValue(value: number): string {
    return `Dia ${value}`;
  }

  alterarPeriodoDaKey(indexOrdenacao: number, keyId: number, alternador: string, event: any) {
    const keyAlterada = this.estimativaCronogramaKeys.find(x => x.id === keyId);

    const valor = event.value || 1;

    if (alternador === 'inicio') {
      keyAlterada.inicioSlideToggle = valor;
    } else if (alternador === 'fim') {
      keyAlterada.fimSlideToggle = valor;
    }

    keyAlterada.dias = keyAlterada.fimSlideToggle - keyAlterada.inicioSlideToggle;

    if (this.tipoCronograma === TipoCronogramaEnum.semanal) {
      keyAlterada.mesInicio = Math.ceil(keyAlterada.inicioSlideToggle / totalDeDiasDaSemana);
      keyAlterada.mesFim = Math.ceil(keyAlterada.fimSlideToggle / totalDeDiasDaSemana);
    } else {
      keyAlterada.mesInicio = Math.ceil(keyAlterada.inicioSlideToggle / totalDeDiasDoMes);
      keyAlterada.mesFim = Math.ceil(keyAlterada.fimSlideToggle / totalDeDiasDoMes);
    }

    keyAlterada.mesInicio = Math.max(1, keyAlterada.mesInicio);
    keyAlterada.mesFim = Math.min(this.periodos.length, keyAlterada.mesFim);

    this.atualizarKey(keyAlterada);
  }

  limpaCronogramaEstimativaKeys() {
    let primeiraKeyVaziaParaOsTitulos = {} as EstimativaCronogramaKey;
    primeiraKeyVaziaParaOsTitulos.slideToggleDisabled = true;
    primeiraKeyVaziaParaOsTitulos.indexOrdenacao = -1;

    this.estimativaCronogramaKeys = [primeiraKeyVaziaParaOsTitulos];
  }

  gerarCronogramaComIA(identificouAlteracaoProjeto: boolean) {
    this.loading = true;

    var texto = '';

    if (identificouAlteracaoProjeto)
      texto = 'Atenção! Identificamos uma alteração no Prazo do Projeto ou uma divergência entre o Total de Horas do Projeto e as horas alocadas no Cronograma, com isso, sugerimos gerar novamente o Cronograma, essa ação irá substituir todo cronograma atual e irá criar outro com base nos parâmetros do Projeto. Confirma ação?';
    else
      texto = 'Atenção! Essa ação irá substituir todo Cronograma atual e irá criar outro com todos os dados zerados. Confirma ação?';

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '580px',
      data: {
        titulo: 'Geração de Cronograma com IA',
        texto: texto
      },
      panelClass: 'default-dialog-container'
    });

    dialogRef.afterClosed().subscribe(resultModal => {
      if (resultModal) {
        this.loading = true;

        const tipoCronograma = this.tipoCronogramaChecked
          ? TipoCronogramaEnum.semanal
          : TipoCronogramaEnum.mensal;

        this.estimativaCronogramaService.gerarCronogramaComIA(this.estimativaId, TipoCronogramaEnum[tipoCronograma])
          .subscribe((resultRequest: any) => {
            if (resultRequest.mensagem == null) {
              this.misc.mensagemSucesso('Cronograma gerado com sucesso');
              this.carregarTela();
            } else {
              this.misc.mostrarAviso(resultRequest.mensagem);
            }
            this.loading = false;
          });
      }
    });

    this.loading = false;
  }


  dragAndDropKey(event: CdkDragDrop<string[]>) {
    this.estimativaCronogramaKeys[event.currentIndex].indexOrdenacao = 100000;
    this.estimativaCronogramaKeys[event.previousIndex].indexOrdenacao = event.currentIndex;
    this.estimativaCronogramaKeys[event.currentIndex].indexOrdenacao = event.previousIndex;

    moveItemInArray(this.estimativaCronogramaKeys, event.previousIndex, event.currentIndex);

    document.getElementsByClassName('mat-btn-white-cancel')[0].dispatchEvent(new MouseEvent('mouseenter', {}));

    this.estimativaCronogramaKeys.forEach((element) => {
      if (element.indexOrdenacao != -1) {
        this.atualizarKey(element);
      }
    });
  }

  removerKey(cronogramaKeyId: number, indexOrdenacao: number) {
    this.estimativaCronogramaKeys.splice(indexOrdenacao, 1);

    if (cronogramaKeyId > 0) {
      this.estimativaCronogramaKeyService.delete(cronogramaKeyId).subscribe(
        () => {
          this.toastr.mostrarMensagem("sucesso", "Sucesso", "Chave do Cronograma excluído com sucesso");
          this.loading = true;
          this.carregarTela();
        },
        (error) => {
          this.misc.processError(error, "Não foi possível excluir a chave do Cronograma.");
          this.loading = false;
        }
      );
    }
  }

  atualizarKey(cronogramaKey) {
    this.loading = true;

    this.estimativaCronogramaKeyService.update(cronogramaKey).subscribe({
      next: () => {
      },
      error: error => {
        this.loading = false;
      }
    }).add(() => {
      this.loading = false;
    });
  }

  atualizarDescricaoKey(event, cronogramaKeyIndex) {
    this.loading = true;

    var descricao = event.srcElement.value;

    let cronogramaKey = this.estimativaCronogramaKeys[cronogramaKeyIndex];
    cronogramaKey.descricao = descricao;

    this.estimativaCronogramaKeyService.update(cronogramaKey).subscribe({
      next: () => {
      },
      error: error => {
        this.loading = false;
      }
    }).add(() => {
      this.loading = false;
    });
  }

  modalAdicionarChave(): void {
    let cronogramaKey: EstimativaCronogramaKey = this.estimativaCronogramaKeys[1];

    const dialogRef = this.dialog.open(AdicionarCronogramaKeyDialogComponent, {
      width: '600px',
      panelClass: 'default-dialog-container',
      data: cronogramaKey
    });

    dialogRef.afterClosed().subscribe(() => {
      this.loading = true;
      this.carregarTela();
    });
  }

  async estimativaAlterouDados(): Promise<boolean> {
    this.loading = true;
    const result: boolean = await this.estimativaCronogramaService.estimativaAlterouDados(this.estimativaId).toPromise();
    return result;
  }

  atualizarDiaInicioKey(event, cronogramaKeyIndex) {
    this.loading = true;

    var diaInicio = event.srcElement.value;

    if (diaInicio == "0") {
      this.misc.processError("Dia Inicio não pode ser igual a 0 (zero)");
      this.loading = false;
    } else {
      let cronogramaKey = this.estimativaCronogramaKeys[cronogramaKeyIndex];
      cronogramaKey.diaInicio = diaInicio;

      var diaInicioNumber = parseInt(cronogramaKey.diaInicio.toString(), 10);
      var diaFimNumber = parseInt(cronogramaKey.diaFim?.toString(), 10);

      if (diaFimNumber > 0 && diaInicioNumber > diaFimNumber) {
        this.misc.processError("Dia Inicio não pode ser menor que Dia Fim.");
        this.loading = false;
      } else {
        this.estimativaCronogramaKeyService.update(cronogramaKey).subscribe({
          next: () => {
          },
          error: error => {
            this.loading = false;
          }
        }).add(() => {
          this.carregarTela();
        });
      }
    }
  }

  atualizarDiaFimKey(event, cronogramaKeyIndex) {
    this.loading = true;

    var diaFim = event.srcElement.value;

    if (diaFim == "0") {
      this.misc.processError("Dia Fim não pode ser igual a 0 (zero)");
      this.loading = false;
    } else {
      let cronogramaKey = this.estimativaCronogramaKeys[cronogramaKeyIndex];
      cronogramaKey.diaFim = diaFim;

      var diaInicioNumber = parseInt(cronogramaKey.diaInicio.toString(), 10);
      var diaFimNumber = parseInt(cronogramaKey.diaFim?.toString(), 10);

      if (diaFimNumber > 0 && diaInicioNumber > diaFimNumber) {
        this.misc.processError("Dia Inicio não pode ser menor que Dia Fim.");
        this.loading = false;
      } else {
        this.estimativaCronogramaKeyService.update(cronogramaKey).subscribe({
          next: () => {
          },
          error: error => {
            this.loading = false;
          }
        }).add(() => {
          this.carregarTela();
        });
      }
    }
  }
}
